import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AuditReportHeaderComponent, AuditReportTableComponent, getEnterpriseLabels, SecurityDomain } from 'lib';
import { TableModule } from 'primeng/table';
import { ReplaySubject, Subject } from 'rxjs';
import { NgIf } from '@angular/common';
import { DomainDetectorService } from '../../services/domain-detector.service';

@Component({
    selector: 'mmoga-audit-reports',
    imports: [
        TableModule,
        AuditReportTableComponent,
        AuditReportHeaderComponent,
        NgIf
    ],
    standalone: true,
    templateUrl: './audit-reports.component.html',
    styleUrl: './audit-reports.component.scss'
})
export class AuditReportsComponent implements OnInit, OnDestroy {
    private readonly domainDetectorService = inject(DomainDetectorService);

    protected destroyed$ = new Subject<void>();

    enterpriseLabels = getEnterpriseLabels(SecurityDomain.MODMED);
    reloadDataSubject = new ReplaySubject<boolean>(1);

    ngOnInit(): void {
        this.enterpriseLabels = getEnterpriseLabels(this.domainDetectorService.getDomainConfig().securityDomain);
        this.emitReloadData();
    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    emitReloadData(): void {
        this.reloadDataSubject.next(true);
    }
}
